export function normalizeVariationProperties(properties, { selection, sortByPriority })
{
  let result = properties;

  if (!result || result.length === 0) {
    return [];
  }
  const isGroupFormat = !!properties[0].properties;

  if (isGroupFormat) {
    result = result.flatMap((vp) => vp.properties);
  } else {
    result = result.map((vp) => ({ ...vp.property, values: vp.values }));
  }

  result = result
    .filter((p) => !!selection[p.id])
    .map((p) => ({ selection: selection[p.id], value: p }));

  if (sortByPriority) {
    result = result.sort((a, b) => {
      const aPrio = a.selection.priority;
      const bPrio = b.selection.priority;

      return aPrio - bPrio;
    });
  }

  return result;
}

export default {
  methods: {
    normalizeVariationProperties,
  },
};
